import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface INumberOfRooms {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  oneRoom?: number | null;
  twoRooms?: number | null;
  threeRooms?: number | null;
  fourRooms?: number | null;
  fiveRooms?: number | null;
  sixRooms?: number | null;
  sevenRooms?: number | null;
  eightRooms?: number | null;
  nineOrMoreRooms?: number | null;
}

export const defaultValue: Readonly<INumberOfRooms> = {};
